// /sesion-kine/:sessionId — detalle de una sesión para el kine: ángulo y
// calidad por repetición, observaciones automáticas y comparación con la
// sesión anterior. Envuelve DetalleSesionKine con el shell del kine.

import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { KineHeader } from '../components/kine/KineHeader';
import { KineSidebar } from '../components/kine/KineSidebar';
import { DetalleSesionKine } from '../components/sessions/DetalleSesionKine';
import { useKineProfile } from '@/lib/supabase/queries/useKineProfile';
import { useDetalleSesionKine } from '@/lib/supabase/queries/useDetalleSesionKine';

export function SesionKineDetalle() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { data: kineProfile } = useKineProfile();
  const { data, loading, error } = useDetalleSesionKine(sessionId);

  const irAPaciente = (tab?: string) => {
    if (!data) return;
    const id = data.sesion.paciente.id;
    navigate(tab ? `/paciente/${id}?tab=${tab}` : `/paciente/${id}`);
  };

  // Umbral de referencia: 90% del ángulo medio de la sesión, redondeado a 5°.
  const umbral = data && data.sesion.reps.length > 0
    ? Math.round(
        (data.sesion.reps.reduce((a, r) => a + r.angleMax, 0) /
          data.sesion.reps.length) * 0.9 / 5,
      ) * 5
    : undefined;

  return (
    <div className="min-h-screen bg-background transition-colors duration-200">
      <KineHeader
        kineNombre={kineProfile?.nombre || '—'}
        onMenuClick={() => setDrawerOpen(true)}
      />
      <div className="flex">
        <KineSidebar
          activeKey="pacientes"
          mobileOpen={drawerOpen}
          onMobileClose={() => setDrawerOpen(false)}
        />
        <div className="flex-1 min-w-0">
          {loading && (
            <p className="text-center text-muted-foreground py-16">Cargando sesión…</p>
          )}
          {error && !loading && (
            <div className="p-8">
              <div className="bg-card rounded-2xl p-6 border border-border text-center">
                <p className="text-orange-600 font-semibold mb-2">No pudimos cargar la sesión</p>
                <p className="text-sm text-muted-foreground">{error}</p>
              </div>
            </div>
          )}
          {data && !loading && (
            <DetalleSesionKine
              sesion={data.sesion}
              umbralAngulo={umbral}
              violationLabels={data.violationLabels}
              onVolver={() => navigate('/')}
              onEnviarMensaje={() => irAPaciente('mensajes')}
              onAjustarRutina={() => irAPaciente('rutinas')}
              onIrATodasLasSesiones={() => irAPaciente('sesiones')}
            />
          )}
        </div>
      </div>
    </div>
  );
}
